module.exports = __webpack_public_path__ + "bcbd71aad81534711ca96b91ef6ea521.svg";